import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ApiService } from 'src/app/api/api.service';
import { GlobalService } from 'src/app/api/global.service';
import { StepTypes } from '../../steps/StepTypes';
import Dropzone from 'dropzone';



@Component({
  selector: 'app-upload',
  templateUrl: './upload.component.html',
  styleUrls: ['./upload.component.scss'],
})
export class UploadComponent implements OnInit {

  dropzone?: Dropzone;
    uploaded_files = [];
    @Input() folder_guid = '0';
    @Input() additional_data: any = null; // Additional data that can be passed to the component, such as document_request_guid for email document requests
    @Input() title = 'Upload Files to Step';
    // Only set by callers uploading against an Upload File-type step (see table.component.ts's
    // presentStepFileUpload/presentSpecificFileUpload) - drives the important/internal-only note below,
    // so a team member doesn't have to go remember what they configured on the step itself.
    @Input() step: any = null;

    IsUploadFileStep(): boolean {
      return this.step?.type === StepTypes.upload_file || this.step?.type === StepTypes.important_file_upload;
    }

    WillMarkImportant(): boolean {
      if (this.step?.type === StepTypes.important_file_upload) return true;
      return !!this.step?.data?.mark_files_important;
    }

    WillBeInternalOnly(): boolean {
      return this.step?.type === StepTypes.upload_file && !!this.step?.data?.internal_only;
    }
  
    ngAfterViewInit() {
      this.dropzone = new Dropzone('#dropzone', {
        url: '/fake-upload-endpoint', // Required but unused unless autoProcessQueue is true
        autoProcessQueue: false,
        addRemoveLinks: true,
        parallelUploads: 1,
      });
    }
  
  
    constructor(private modalController: ModalController, private apiService: ApiService, public globalService: GlobalService) { }
  
    ngOnInit() {
      console.log("FOLDER GUID: " + this.folder_guid);
    }
  
    async confirmUpload() {
      if (!this.dropzone) return;
  
      const files = this.dropzone.getAcceptedFiles();
      const uploadPromises: Promise<void>[] = [];
  
      for (const file of files) {
        let file_guid = await this.apiService.UploadFile(file, this.folder_guid, this.additional_data);
        if (file_guid != null) {
          let push_data = {
            guid: file_guid,
            file_name: file.name,
          }
          this.uploaded_files.push(push_data);
        }
      }
      this.modalController.dismiss(this.uploaded_files);
    }
  
  
  
    clearFiles() {
      this.dropzone?.removeAllFiles(true);
    }
    ngOnDestroy() {
      this.dropzone?.destroy();
    }
  
    async Close() {
      this.modalController.dismiss(false);
    }

}
